import React from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import Home from './View/Home.js';
import Product from './View/Product.js';

import Grid from '@material-ui/core/Grid';
import './App.css';
import Toolbar from './Components/Toolbar';
import { makeStyles } from '@material-ui/core/styles';
import Footer from './Components/Footer';
import Contact from './View/Contact';

const useStyles = makeStyles((theme) => ({
  markdown: {
    ...theme.typography.body1,
    backgroundColor: 'white',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

function App() {
  const classes = useStyles();

  return (
    <div style={{ backgroundColor: 'rgba(4, 4, 4, 0.4)' }}>
      <Router onUpdate={() => window.scrollTo(0, 0)}>
        <Grid className={classes.markdown} item xs={12} md={8}>
          <Toolbar />
          <Switch>
            <Route path="/product">
              <Product />
            </Route>
            <Route path="/contact">
              <Contact />
            </Route>

            <Route exact path="/">
              <Home />
            </Route>
          </Switch>
          <Footer />
        </Grid>
      </Router>
    </div>
  );
}

export default App;
